import React from "react"
import { ScrapReturnForm as TheftCreationForm } from "../ScrapReturn"

const TheftForm = ({ ...rest }) => {
    return <TheftCreationForm isTheft={true} {...rest} />
}

export default TheftForm
